export const getSmsCode = {
    path: "/login/getSmsCode",
    method: "post"
}
export const loginByPhone = {
    path: "/login/loginByPhone",
    method: "post"
}
// 账号密码登录
export const loginByAccount = {
    path: "/login/loginByAccount",
    method: "post"
}
// 刷新令牌
export const refreshToken = {
    path: "/login/refreshToken",
    method: "post"
}
// 订单
// localhost:18081/xdk/?page=1&size=1
export const getUserCardOrder = {
    path: "/userCardOrder/getUserCardOrder",
    method: "get"
}
// 获取用户信息
export const getUserInfo = {
    path: "/userProfileInfo/getUserInfo",
    method: "POST"
}
export const getVipExpiresDate = {
    path: "/userMemberStatus/getVipExpiresDate",
    method: "POST"
}
export const bindMobile = {
    path: "/login/bindMobile",
    method: "POST"
}

// 安全验证
export const getAuthImg = {
    path: "/piccode/getPicCode",
    method: "POST"
}

export const getAuthCode = {
    path: "/piccode/checkClient",
    method: "POST"
}

// 微信授权
export const wechatAuth = {
    path: "/login/getWechatInfo",
    method: "POST"
}
// 微信授权登录
export const wechatLogin = {
    path: "/login/loginByWechat",
    method: "POST"
}
// export const getRealData={
//     path:"/business/getRealData",
//     method:"post"
// }
// 获取会员模板
export const getCardModel = {
    path: "/cardDefinition/getCardModel",
    method: "POST"
}
// 生成订单
export const buyCard = {
    path: "/userCardOrder/buyCard",
    method: "POST"
}
// 支付订单
export const toPayCardOrder = {
    path: "/pay/toPayCardOrder",
    method: "POST"
}
// 修改密码
export const forgetPassword = {
    path: "/login/forgetPassword",
    method: "POST"
}
export const upload = {
    path: "/common/upload",
    method: "POST"
}
export const updateUserProfileInfo = {
    path: "/userProfileInfo/updateUserProfileInfo",
    method: "POST"
}

// 推荐中心/推荐会员的统计数据
export const getStatisticalData = {
    path: "/referrer/index",
    method: "GET"
}
// 推荐中心/推荐会员的列表
export const getRecommendationList = {
    path: "/referrer/list",
    method: "GET"
}
// 推荐中心/推荐会员的曲线
export const getRecommendationCurve = {
    path: "/referrer/line",
    method: "GET"
}

// 佣金流水/统计
export const getPaidStatistics = {
    path: "/paid/index",
    method: "GET"
}
// 佣金流水/记录
export const getPaidList = {
    path: "/paid/list",
    method: "GET"
}

// 提现申请/列表
export const getWithdrawList = {
    path: "/withdraw/list",
    method: "GET"
}
// 提现申请/申请
export const addWithdraw = {
    path: "/withdraw/add",
    method: "POST"
}
// 提现申请/作废
export const deleteWithdraw = {
    path: "/withdraw/edit",
    method: "POST"
}

// 收款渠道/列表
export const getPaidChannelList = {
    path: "/paidChannel/list",
    method: "GET"
}
// 收款渠道/添加
export const addPaidChannel = {
    path: "/paidChannel/add",
    method: "POST"
}
// 收款渠道/修改
export const updatePaidChannel = {
    path: "/paidChannel/edit",
    method: "POST"
}
// 收款渠道/删除
export const deletePaidChannel = {
    path: "/paidChannel/delete",
    method: "GET"
}








// WEBPACK FOOTER //
// ./src/api/home.js